import React, {
    FunctionComponent,
    PropsWithChildren,
    useContext,
    useEffect,
} from 'react'
import { useInView } from 'react-intersection-observer'
import AnchorNavigationContext from '../anchor-navigation/anchorNavigationContext'
import { APP_ROOT_ID } from '../../constants/appConstants'

export type Props = PropsWithChildren<{
    id: string
}>

const Anchor: FunctionComponent<Props> = (props) => {
    const { id, children } = props

    const { addVisibleAnchor, removeVisibleAnchor } = useContext(AnchorNavigationContext)
    const { ref, inView, entry } = useInView({
        rootMargin: '-105px',
    })

    const root = document.getElementById(APP_ROOT_ID)
    const top = (root ? root.scrollTop : window.scrollY) + (entry?.boundingClientRect.y || 0)

    useEffect(() => {
        if (inView) {
            addVisibleAnchor({
                id,
                top,
            })
        } else {
            removeVisibleAnchor(id)
        }
    }, [inView]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div id={id} className="anchor" />
            <div ref={ref}>
                {children}
            </div>
        </>
    )
}

export default Anchor
